import { Store } from "vuex";
import { settingsActionsLists } from "@service/store/settings/actions-list";

export class LanguagesService {
    private _selected = '';
    private readonly _baseLanguage: string = '';
    private readonly _otherLanguages: string[] = [];

    constructor(
        private readonly _list: string[],
        private readonly _userLanguage: string,
        selected = ''
    ) {
        this._selected = selected || _userLanguage;
        this._baseLanguage = _list.length ? _list[0] : '';
        this._otherLanguages = _list.slice(1);
    }

    get hasLanguages(): boolean {
        return this._list.length > 0;
    }

    get selected() {
        return this._selected;
    }

    get selectedLabel() {
        return this._selected.toUpperCase();
    }

    get list() {
        return this._list;
    }

    get otherLanguages() {
        return this._otherLanguages;
    }

    get baseLanguage() {
        return this._baseLanguage;
    }

    get userLanguage() {
        return this._userLanguage;
    }

    get languagesWithoutUsersOne() {
        return this._list.filter(item => item != this._userLanguage);
    }

    setSelectedLanguage(language: string) {
        if (!this._list.includes(language)) { return; }

        this._selected = language;
    }

    get isSelectedLanguageBase() {
        return this._baseLanguage == this._selected;
    }
}

export const createLanguageService  = async (store: Store<any>, selected = ''): Promise<LanguagesService> => {
    const languagesList = await store.dispatch(settingsActionsLists.loadLanguages);
    return new LanguagesService(languagesList, store.getters.language, selected);
}
